/**
 * WelcomeToast — İlk giriş karşılama (bond_score=0, total_interactions=0)
 * "Filiz" adıyla gösterilir — agent ismi açıklanmaz (Rule 11)
 */
import { PartyPopper, X } from 'lucide-react';
import { memo, useEffect, useState } from 'react';
import { API_URL, apiFetch } from '../../../config/api';
import { useOpenWindow } from '../../../hooks/useOpenWindow';

function WelcomeToast() {
  const [show, setShow] = useState(false)
  const [name, setName] = useState('')
  const openWindow = useOpenWindow()

  useEffect(() => {
    if (localStorage.getItem('welcome_shown')) return

    apiFetch(`${API_URL}/api/twin/me`)
      .then(r => r.json())
      .then((d: any) => {
        const profile = d.profile ?? d
        const bond = profile?.bond_score ?? 1
        const interactions = profile?.total_interactions ?? 1
        const displayName = profile?.twin_name?.replace(' Twin', '') ?? ''
        if (bond === 0 && interactions === 0) {
          setName(displayName)
          setTimeout(() => setShow(true), 2000)
        }
      })
      .catch(() => {})
  }, [])

  const handleClose = () => {
    setShow(false)
    localStorage.setItem('welcome_shown', '1')
  }

  const handleAction = () => {
    openWindow('twin-window', 'Digital Twin', 800, 600, true)
    handleClose()
  }

  if (!show) return null

  return (
    <div style={{
      position: 'fixed', bottom: 80, right: 20, zIndex: 9999,
      width: 320, padding: '14px 16px',
      background: 'var(--os-card)', border: '1px solid var(--os-border)',
      borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      display: 'flex', flexDirection: 'column', gap: 10,
      animation: 'slideUp 0.3s ease',
    }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'linear-gradient(135deg, #8b5cf6, #3b82f6)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>✨</div>
          <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--os-text)' }}>Filiz</span>
        </div>
        <button onClick={handleClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--os-muted)', padding: 2 }}>
          <X size={14} />
        </button>
      </div>
      <p style={{ fontSize: 12, color: 'var(--os-text)', lineHeight: 1.5, margin: 0 }}>
        Hoş geldin{name ? ` ${name}` : ''} 👋 Sana özel bir Digital Twin doğurdum — seni tanımak için bekliyor.
      </p>
      <button onClick={handleAction} style={{
        padding: '7px 14px', background: 'linear-gradient(135deg, #8b5cf6, #3b82f6)',
        color: '#fff', border: 'none', borderRadius: 8, fontSize: 11,
        fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', alignSelf: 'flex-start',
      }}>
        Twin'le tanış →
      </button>
      <style>{`@keyframes slideUp { from { opacity:0; transform:translateY(20px) } to { opacity:1; transform:translateY(0) } }`}</style>
    </div>
  )
}

export default memo(WelcomeToast)

